/**
 * @param {List} resultList
 * @param {string} keyAttribute
 * @param {string} format
 */
export default function responseFormatter(resultList, keyAttribute, format) {
  if (format === 'list') {
    return resultList;
  }
  const resultMap = {};

  resultList.forEach((column) => {
    resultMap[column[keyAttribute]] = column;
  });

  return resultMap;
}
